import React from 'react';
import appConfig from '../../config/appConfig';
import { Logo, Profile } from '../common';
import './header.less';

const Header = () => {
  const width = appConfig?.layout?.sideMenu?.width ?? undefined;

  // TODO: improve styling and stuff later on...

  return (
    <div className="header">
      <div className="logo-wrapper" style={{ width }}>
        <Logo company={'PickPack'} hide={false} />
      </div>
      <div
        className="header-content-container"
        style={{ flex: 1, display: 'flex', justifyContent: 'space-between' }}
      >
        <div />
        {/* <SearchInput/> */}
        <Profile />
      </div>
    </div>
  );
};

export default Header;
